import React, { Component } from "react";
import { Text } from "@jobmatchme/ui";
import styles from "./style.module.scss";
import facebookIcon from "./icons/facebook.svg";
import linkedinIcon from "./icons/linkedin.svg";
import twitterIcon from "./icons/twitter.svg";
import xingIcon from "./icons/xing.svg";
import emailIcon from "./icons/email.svg";

class ShareButtons extends Component {
  constructor() {
    super();

    this.state = {
      url: ""
    };
  }

  componentDidMount() {
    this.setState({
      url: window.location.href
    });
  }

  getShareLink = platform => {
    const shareLinks = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${
        this.state.url
      }`,
      linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${
        this.state.url
      }&title=&summary=&source=`,
      twitter: `https://twitter.com/home?status=${this.state.url}`,
      xing: `https://www.xing.com/spi/shares/new?url=${this.state.url}`,
      email: `mailto:me@me.com?body=${this.state.url}`
    };

    if (shareLinks[platform]) {
      return shareLinks[platform];
    }

    return this.state.url;
  };

  render() {
    return (
      <>
        <Text align="center">Diesen Artikel teilen</Text>
        <div className={styles.shareButtons}>
          <div className={styles.shareButton}>
            <a
              target="_blank"
              rel="nofollow noopener noreferrer"
              href={this.getShareLink("facebook")}
            >
              <img src={facebookIcon} alt="facebook" />
            </a>
          </div>
          <div className={styles.shareButton}>
            <a
              target="_blank"
              rel="nofollow noopener noreferrer"
              href={this.getShareLink("linkedin")}
            >
              <img src={linkedinIcon} alt="linkedIn" />
            </a>
          </div>
          <div className={styles.shareButton}>
            <a
              target="_blank"
              rel="nofollow noopener noreferrer"
              href={this.getShareLink("xing")}
            >
              <img src={xingIcon} alt="xing" />
            </a>
          </div>
          <div className={styles.shareButton}>
            <a
              target="_blank"
              rel="nofollow noopener noreferrer"
              href={this.getShareLink("twitter")}
            >
              <img src={twitterIcon} alt="twitter" />
            </a>
          </div>
          <div className={styles.shareButton}>
            <a href={this.getShareLink("email")}>
              <img src={emailIcon} alt="email" />
            </a>
          </div>
        </div>
      </>
    );
  }
}

export default ShareButtons;
